import { useLazyGetContractsQuery } from '@/api/queries/contract';

import {
  type PaidSpecContractType,
  type SpecContractType,
} from '../types/contract';

import { useTimerToSpecContractOpeningEnd } from './timer-to-spec-contract-opening-end';

const useOpenSpecContractTimer = (
  kind: SpecContractType | PaidSpecContractType,
  endTimeCallback: () => void,
): number | null => {
  const [getContracts] = useLazyGetContractsQuery();

  return useTimerToSpecContractOpeningEnd(kind, () => {
    endTimeCallback();
    getContracts();
  });
};

export { useOpenSpecContractTimer };
